import { render, staticRenderFns } from "./MacroItem.vue?vue&type=template&id=d6041d58&scoped=true&"
import script from "./MacroItem.vue?vue&type=script&lang=js&"
export * from "./MacroItem.vue?vue&type=script&lang=js&"
import style0 from "./MacroItem.vue?vue&type=style&index=0&id=d6041d58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6041d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6041d58')) {
      api.createRecord('d6041d58', component.options)
    } else {
      api.reload('d6041d58', component.options)
    }
    module.hot.accept("./MacroItem.vue?vue&type=template&id=d6041d58&scoped=true&", function () {
      api.rerender('d6041d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/Macros/MacroItem.vue"
export default component.exports